import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZefFormFieldComponent } from './form-field.component';

@NgModule({
  declarations: [ ZefFormFieldComponent ],
  imports: [ CommonModule ],
  exports: [ ZefFormFieldComponent ]
})
export class ZefFormFieldModule { }
